import { array, boolean, number, object, string } from "superstruct";

import TikTokDisplaySettinsSchema from "./TikTokDisplaySettingsSchema";

const TikTokGallerySchema = object({
    id: number(),
    title: string(),
    published: boolean(),
    displaySettings: array(TikTokDisplaySettinsSchema),
    hideBranding: boolean(),
    allowInstantPurchase: boolean(),
});

export default TikTokGallerySchema;
